<template>
  <v-container fluid>
    <v-row class="mb-2">
      <v-col>
        <v-btn depressed color="primary" @click="createBundles">
          Создать
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          fixed-header
          :headers="headers"
          :items="getBundlesList"
          :items-per-page="-1"
          class="elevation-1 menu-list"
        >
          <!-- eslint-disable-next-line -->
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="accent"
                  class="mr-2"
                  elevation="1"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="goToItem(item.id, true)"
                >
                  <!-- eslint-disable-next-line -->
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Редактировать</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="accent"
                  class="mr-2"
                  elevation="1"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="goToItem(item.id)"
                >
                  <!-- eslint-disable-next-line -->
                  <v-icon small>mdi-arrange-send-backward</v-icon>
                </v-btn>
              </template>
              <span>Перейти</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="accent"
                  elevation="1"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="openDeleteModal(item.id)"
                >
                  <!-- eslint-disable-next-line -->
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            Вы действительно хотите удалить набор?
          </v-card-title>
          <v-card-text>
            Эту операцию невозможно будет отменить, вы точно хотите
            набор?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="closeModal">
              Отмена
            </v-btn>
            <v-btn color="red darken-1" text @click="deleteItem">
              Согласен
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        deleteId: null,
        dialog: false,
        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Слаг', value: 'slug', align: 'start' },
          { text: 'Цена', value: 'price.formatted', align: 'start' },
          { text: 'Действия', value: 'actions', align: 'end', sortable: false },
        ],
      }
    },
    computed: {
      ...mapGetters({
        getBundlesList: 'bundles/getBundlesList',
      }),
    },
    created () {
      this.$store.dispatch('bundles/fetchBundlesList', {
        limit: 10000000,
        offset: 0,
        page: 1,
      })
    },
    methods: {
      openDeleteModal (id) {
        this.deleteId = id
        this.dialog = true
      },
      closeModal () {
        this.deleteId = null
        this.dialog = false
      },
      deleteItem () {
        this.$store.dispatch('bundles/deleteBundles', this.deleteId)
        this.dialog = false
      },
      goToItem (id, edit = false) {
        this.$router.push({ name: 'Набор', params: { id: id, isedit: edit } })
      },
      createBundles () {
        this.$router.push('/bundles/create')
      },
    },
  }
</script>
